<template>
  <v-container>
    <v-overlay :value="loading_overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-container>
        <div>Studio {{ $route.params.id }}</div>
        <v-row class="my-4">
          <v-col cols="12" md="4">
            <v-text-field
              label="Nome Studio"
              v-model="form.STUDIO_NAME.val"
              :rules="[rules.required, rules.max(32)]"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                label="Codice Studio"
                v-model="form.STUDIO_CODE.val"
                :rules="[rules.required, rules.max(32), rules.alphanumeric()]"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              label="Sotto Dominio"
              v-model="form.STUDIO_SUBDOMAIN.val"
              :disabled="editMode"
              @blur="form.STUDIO_SUBDOMAIN.val = form.STUDIO_SUBDOMAIN.val.toLowerCase();"
              :persistent-hint="true"
              :hint='`Studio Accessibile presso: https://${form.STUDIO_SUBDOMAIN.val}.procedures.cloud - ATTENZIONE!! NON POTRAI PIU CAMBIARLO`'
              :rules="[rules.required, rules.max(16), rules.letters]"
            />
          </v-col>
          <v-col>
            <mj-image text="P"

                      ref="product_image"
                      :image-src="form.studio_avatar.val"
                      @img-changed="updateImage"
                      shape="rectangle"
                      :width="320"
                      :height="240"
            >
            </mj-image>
          </v-col>
        </v-row>
        <v-card class="my-4">
          <v-card-title class="secondary white--text"
            >Configurazione Database MySQL<v-spacer /><v-icon
              class="white--text"
              >mdi-database-outline</v-icon
            ></v-card-title
          >
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field
                  label="DB Host"
                  hint="Indirizzo Ip o dominio del database"
                  v-model="form.TENANT_DB_HOST.val"
                  :rules="[rules.required, rules.max(255)]"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="DB Port"
                  hint="Porta di connessione al db (es. 3306)"
                  v-model="form.TENANT_DB_PORT.val"
                  :rules="[rules.required, rules.max(5), rules.integer]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  label="DB Name"
                  hint="Nome del database"
                  v-model="form.TENANT_DB_DATABASE.val"
                  :rules="[rules.required, rules.max(255)]"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="DB User"
                  hint="Nome utente per l'accesso al db server"
                  v-model="form.TENANT_DB_USERNAME.val"
                  :rules="[rules.required, rules.max(255)]"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="DB Password"
                  hint="Password per l'accesso al db server"
                  v-model="form.TENANT_DB_PASSWORD.val"
                  :append-icon="showDBPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showDBPassword ? 'text' : 'password'"
                  @click:append="showDBPassword = !showDBPassword"
                  :rules="[rules.required, rules.max(255)]"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="d-flex justify-end">
              <v-btn outlined  @click="testDBConnection"
              :loading="test_TENANT_DB_connection_loading"
                >Test DB Connection
                <v-icon>{{ TENANT_DB_connection_test_icon }}</v-icon></v-btn
              >
              </v-col>
            </v-row>
              <v-alert :type="(TENANT_DB_connection_test_status == 1) ? 'info' : 'warning'" v-if='TENANT_DB_connection_test_message.length >  0'  dense class="caption">{{
                TENANT_DB_connection_test_message
              }}</v-alert>
            
          </v-card-text>
          <v-card-actions>
            
          </v-card-actions>
        </v-card>

        <v-card class='mt-3'>
          <v-card-title class="secondary white--text"
            >Configurazione Storage SFTP<v-spacer /><v-icon
              class="white--text"
              >mdi-server</v-icon
            ></v-card-title
          >
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field
                  label="SFTP Host"
                  hint="Indirizzo Ip o dominio"
                  v-model="form.STUDIO_SFTP_HOST.val"
                  :rules="[ rules.max(255)]"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="SFTP Port"
                  hint="Porta di connessione a sftp (es. 22)"
                  v-model="form.STUDIO_SFTP_PORT.val"
                  :rules="[ rules.max(5), rules.integer]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Root Directory"
                  hint="Percorso di base"
                  v-model="form.STUDIO_SFTP_ROOT_DIRECTORY.val"
                  :rules="[ rules.max(255)]"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="SFTP User"
                  hint="Nome utente per l'accesso al SFTP server"
                  v-model="form.STUDIO_SFTP_USERNAME.val"
                  :rules="[ rules.max(255)]"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="SFTP Password"
                  hint="Password per l'accesso al SFTP server"
                  v-model="form.STUDIO_SFTP_PASSWORD.val"
                  :append-icon="showSFTPPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showSFTPPassword ? 'text' : 'password'"
                  @click:append="showSFTPPassword = !showSFTPPassword"
                  :rules="[ rules.max(255)]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex justify-end">
              <v-btn outlined  @click="testSFTPConnection" :loading="test_sftp_connection_loading"
                >Test SFTP Connection
                <v-icon>{{ sftp_connection_test_icon }}</v-icon></v-btn
              >
              </v-col>
            </v-row>
              <v-alert :type="(sftp_connection_test_status == 1) ? 'info' : 'warning'" v-if='sftp_connection_test_message.length >  0' dense class="caption">{{
                sftp_connection_test_message
              }}</v-alert>
            
          </v-card-text>
          <v-card-actions>
            
          </v-card-actions>
        </v-card>

        <SchedaToolbar
          :error_show="error_show"
          :error_text="error_text"
          :edit_not_saved="edit_not_saved"
          :edit_mode="editMode"
          :new_button_visibile="true"
          v-on:newItemClick="newItem()"
          v-on:saveItemClick="saveItem()"
          v-on:goBackClick="goBack()"
        />
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import schedaMixin from "@/mixins/SchedaMixin.js";
import ValidationRulesMixin from "@/mixins/ValidationRulesMixin.js";
import SchedaToolbar from "@/components/SchedaToolbar.vue";
import mj_axios from "@/mj_axios.js";
import MjImage from "@/components/MjImage";

export default {
  STUDIO_NAME: "SchedaEntitaEsempio",
  mixins: [schedaMixin, ValidationRulesMixin],
  components: {
    SchedaToolbar,MjImage
  },
  computed: {
    sftp_connection_test_icon: function () {
      let ret = "";
      if (this.sftp_connection_test_status == 1) {
        ret = "mdi-check";
      } else if (this.sftp_connection_test_status < 0) {
        ret = "mdi-alert";
      }
      return ret;
    },
    TENANT_DB_connection_test_icon: function () {
      let ret = "";
      if (this.TENANT_DB_connection_test_status == 1) {
        ret = "mdi-check";
      } else if (this.TENANT_DB_connection_test_status < 0) {
        ret = "mdi-alert";
      }
      return ret;
    },
  },
  data: () => ({
    TENANT_DB_connection_test_status: null,
    TENANT_DB_connection_test_message: "",
    test_TENANT_DB_connection_loading: false,
    sftp_connection_test_status: null,
    sftp_connection_test_message: "",
    test_sftp_connection_loading: false,
    form: {
      STUDIO_NAME: { type: "string", val: "" },
      STUDIO_SUBDOMAIN: { type: "string", val: "" },
      STUDIO_CODE: { type: "string", val: "" },
      TENANT_DB_HOST: { type: "string", val: "" },
      TENANT_DB_PORT: { type: "string", val: "" },
      TENANT_DB_DATABASE: { type: "string", val: "" },
      TENANT_DB_USERNAME: { type: "string", val: "" },
      TENANT_DB_PASSWORD: { type: "string", val: "" },

      STUDIO_SFTP_HOST: { type: "string", val: "" },
      STUDIO_SFTP_PORT: { type: "string", val: "" },
      STUDIO_SFTP_ROOT_DIRECTORY: { type: "string", val: "" },
      STUDIO_SFTP_USERNAME: { type: "string", val: "" },
      STUDIO_SFTP_PASSWORD: { type: "string", val: "" },

      studio_avatar: {type: "string", val: null}


    },
    showDBPassword: false,
    showSFTPPassword: false,
    apiUrl: "/api/studio",
  }),

  methods: {
    
    testSFTPConnection: function () {
      this.test_sftp_connection_loading = true;
       let params = {};
          Object.keys(this.form).forEach(key => {
            const obj = this.form[key];
            if (obj)
               params[key] = obj.val; 
          });

      mj_axios
        .post("/api/studio/test_sftp_connection", params)
        .then((response) => {
          
          this.sftp_connection_test_message = response.data.message;
          this.sftp_connection_test_status = response.data.code;
        })
        .catch((e) => {
          let message =
            e.response && e.response.data ? e.response.data.message : null;
          this.error_show = true;
          if (e.response && e.response.data && e.response.data.message) {
            message = e.response.data.message;
          }
          this.error_text = `Errore nel Salvataggio dati  ${
            message ? message : ""
          }`;
        })
        .then(() => {
          this.loading_overlay = false;
          this.test_sftp_connection_loading = false;
        });
    },

    testDBConnection: function () {
      // if (this.TENANT_DB_connection_test_status < 0) this.TENANT_DB_connection_test_status = 1;
      // else this.TENANT_DB_connection_test_status = -1;
    this.test_TENANT_DB_connection_loading = true;
      
       let params = {};
          Object.keys(this.form).forEach(key => {
            const obj = this.form[key];
            if (obj)
               params[key] = obj.val; 
          });

      mj_axios
        .post("/api/studio/test_db_connection", params)
        .then((response) => {
          
          this.TENANT_DB_connection_test_message = response.data.message;
          this.TENANT_DB_connection_test_status = response.data.code;
        })
        .catch((e) => {
          let message =
            e.response && e.response.data ? e.response.data.message : null;
          this.error_show = true;
          if (e.response && e.response.data && e.response.data.message) {
            message = e.response.data.message;
          }
          this.error_text = `Errore nel Salvataggio dati  ${
            message ? message : ""
          }`;
        })
        .then(() => {
          this.loading_overlay = false;
          this.test_TENANT_DB_connection_loading = false;
        });
    },
    updateImage(image){
      this.form.studio_avatar.val = image;
    },
    saveItem:function(){

      //overload per aggiungere l'aggiornamento della route dopo il salvataggio anche in editmode
      schedaMixin.methods.saveItem.call(this).then(() => {
        if (this.$route.params.id !== this.form.STUDIO_CODE.val) {
          this.$router.replace(
              this.$route.path.replace(this.$route.params.id, this.form.STUDIO_CODE.val)
          );
        }
      });
    }

  },
  watch:{
   // 'form.STUDIO_CODE': {
   //   handler: function (newVal) {
   //     console.log('studio code changed ' + newVal.val);
   //   },
   //   deep:true
   // }
  }
};
</script>
